import { render } from "./todoItem.vue?vue&type=template&id=4acd537a&scoped=true"
import script from "./todoItem.vue?vue&type=script&lang=js"
export * from "./todoItem.vue?vue&type=script&lang=js"

import "./todoItem.vue?vue&type=style&index=0&id=4acd537a&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4acd537a"]])

export default __exports__